<template>
  <div class="cookie-consent-popup" v-if="showCookieConsent">
    <div class="card-cookie">
      <div class="cookieContent">
        <div class="cookieDescription">
          <p style="color: var(--contrast-base-color)">
            {{ $t("cookies_consent_text_popup") }}
            <a class="cookie-ref" href="/cookiespolicy">
              {{ $t("cookies_consent_link") }} </a
            >.
          </p>
        </div>
        <div class="cont-buttons">
          <!-- <a @click="rejectCookies" class="declineText">{{
            $t("cookies_reject_all_cookies")
          }}</a> -->
          <button @click="closePopup" class="accept-Button accept-necesary-Button">
            {{ $t("cookies_accept_only_necessary") }}
          </button>
          <button @click="acceptCookies" class="accept-Button">
            {{ $t("cookies_accept_all_cookies") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      showCookieConsent: !Cookies.get("cookiesAccepted") && !localStorage.getItem("essencialCookies"),
    };
  },
  methods: {
    acceptCookies() {
      Cookies.set("cookiesAccepted", "true", { expires: 365 });
      localStorage.setItem("acceptedCookies", true);

      this.$emit("cookies-accepted");

      this.showCookieConsent = false;
    },
    closePopup() {
      this.showCookieConsent = false;
      localStorage.setItem("acceptedCookies", false);
      localStorage.setItem("essencialCookies", true);
      this.$emit("rejected");
      if (this.isToken) {
        Cookies.remove("Token");
        Cookies.remove("Userid");
        Cookies.remove("username");
        window.location.reload();
      }
    }
  },
};
</script>

<style scoped>
.cookie-consent-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-top: #928c8c 1px solid;
  min-height: 100px;
  border-radius: 5px;
  background-color: var(--base-color);
  padding: 10px 0;
}
.cookieContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: transparent;
  flex-direction: row;
  gap: 20px;
}

.card-cookie {
  width: 100%;
  display: flex;
  justify-content: center;
}

.cookieDescription {
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-left: 20px;
  flex: 1;
}

.cookieDescription p {
  margin: 0;
}

.cookieDescription a {
  --tw-text-opacity: 1;
  color: var(--contrast-base-color);
}

.cookieDescription a:hover {
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}

.accept-Button {
  width: auto;
  min-height: 40px;
  background-color: var(--success-color);
  transition-duration: 0.2s;
  border: none;
  color: var(--base-color);
  cursor: pointer;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.6s ease;
  border-radius: 30px;
}
.accept-Button:hover {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}

.accept-necesary-Button {
  background-color: var(--success-color);
}

.declineText {
  cursor: pointer;
  color: var(--success-color);
  text-decoration: underline;
}

.cont-buttons {
  width: auto;
  min-width: 30%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 20px;
  padding-right: 30px;
  flex-wrap: wrap;
}
.close-button {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .cookieContent {
    flex-direction: column;
    padding: 10px;
  }

  .cookieDescription {
    padding: 10px;
    text-align: center;
  }

  .cont-buttons {
    width: 100%;
    justify-content: center;
    padding: 10px;
  }

  .accept-Button {
    font-size: 11px;
    padding: 8px 12px;
  }
}

@media screen and (max-width: 480px) {
  .cont-buttons {
    gap: 10px;
  }
  
  .cookieDescription {
    font-size: 12px;
  }
}
</style>
